<template>
    <v-sheet>
        <v-tabs v-model="levelOneTab" color="primary" density="compact">
            <v-tab value="Job">Job</v-tab>
            <v-tab value="Job Details" @click="handleJobDetailsClick">Job Details</v-tab>
            <v-tab value="Engineering" @click="handleEngineeringClick">Engineering</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelOneTab" class="py-3">
            <v-window-item value="Job">
                <JobWindow
                    v-model:job="job"
                    @job-selected-from-search="selectedJob => $emit('job-selected-from-search', selectedJob)"
                    @job-updated="(newValue) => $emit('job-updated', newValue)"
                    ref="JobWindowRef"
                />
            </v-window-item>

            <v-window-item value="Job Details">
                <JobDetailsWindow ref="JobDetailsWindowRef" />
            </v-window-item>

            <v-window-item value="Engineering">
                <Engineering />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script>
import {ref, defineAsyncComponent} from "vue";
import Engineering from "./JobEntryDetails/Engineering.vue";
import JobWindow from "./JobEntryDetails/JobWindow.vue";
import JobDetailsWindow from "./JobEntryDetails/JobDetailsWindow.vue";
import {mapWritableState} from "pinia";
import { useJobEntryStore } from "../../../stores/ProjectManagement/JobEntry";

export default {
    name: "JobEntryDetails",
    components: { JobWindow, JobDetailsWindow, Engineering },
    emits: ["job-selected-from-search", "job-updated"],
    computed: {
        ...mapWritableState(useJobEntryStore, {
            job: "job",
            levelOneTab: "levelOneTab",
            levelTwoTab: "levelTwoTab",
            levelThreeTab: "levelThreeTab",
        })
    },
    setup(props){
        const jobEntryStore = useJobEntryStore()
    },
    methods: {
        handleJobDetailsClick() {
            this.levelTwoTab = "Materials";
            this.levelThreeTab = "Detail";
        },
        handleEngineeringClick() {
            this.levelTwoTab = "Parts";
        },
    }
}
</script>

<style scoped>
    .overflow-hidden {
        overflow-x: hidden;
    }
</style>
